import { Spin } from 'antd';
import React, { Suspense } from 'react';

const AuthLayout = (WraperContent) => {
  return function () {
    return (
      <Suspense
        fallback={
          <div className="spin flex items-center justify-center h-screen">
            <Spin />
          </div>
        }
      >
        <WraperContent />
      </Suspense>
    );
  };
};

export default AuthLayout;
